<template>
  <div class="create-leaveType">
    <div class="btn-wrapper mb-10 mr-20 move-right">
      <router-link to="/admin/hrm/leave/settings/leave-type" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      :model="editForm"
      :rules="rules"
      ref="editForm"
      class="white-bg form"
      label-position="left"
      label-width="200px"
      v-loading="loading"
    >
      <h3 class="text-gray bold mt-0 mb-40">Edit Leave Type</h3>
      <div class="mt-20"></div>
      <el-form-item label="Leave Type name" prop="leave_name" class="mt-20">
        <el-input
          v-model="editForm.leave_name"
          placeholder="Type Leave Name e.g Maternity, Annual"
          type="text"
        ></el-input>
      </el-form-item>
      <el-form-item label="Include Weekends?" prop="weekend">
        <el-checkbox-group v-model="editForm.weekend">
          <el-checkbox label="Saturday"></el-checkbox>
          <el-checkbox label="Sunday"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="Exclude Public Holidays?"
        prop="exclude_public_holidays"
      >
        <el-switch v-model="editForm.exclude_public_holidays"></el-switch>
      </el-form-item>
      <el-form-item label="Duration" prop="applicable_days">
        <el-input v-model="editForm.applicable_days" type="text">
          <template slot="append">{{ "days" }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="Gender Based?">
        <el-tooltip
          :content="`Gender Based : ${isGenderBased === true ? 'Yes' : 'No'}`"
          placement="top"
        >
          <el-switch
            v-model="isGenderBased"
            active-color="#066aff"
            @change="resetGenderRadioButton()"
          >
          </el-switch>
        </el-tooltip>
      </el-form-item>
      <div v-if="isGenderBased === true">
        <el-form-item
          label="Gender"
          prop="gender"
          class="center-middle genderField"
        >
          <el-radio-group v-model="editForm.gender" name="gender">
            <el-radio
              v-for="item in genderList"
              :key="item.id"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="Description" prop="note">
        <el-input type="textarea" v-model="editForm.note" :rows="3"></el-input>
      </el-form-item>
      <el-form-item label="Paid Leave Type" prop="is_paid">
        <el-checkbox v-model="editForm.is_paid"
          >This is a paid leave type</el-checkbox
        >
      </el-form-item>
      <h3>Apply to</h3>
      <el-form-item label="All Branches?" prop="is_generic">
        <el-switch v-model="editForm.is_generic"></el-switch>
      </el-form-item>
      <div v-if="!editForm.is_generic">
        <el-form-item label="Select Branch" prop="branch_id" class="mt-20">
          <el-select
            v-model="editForm.branch_id"
            placeholder="Select"
            style="width: 542px"
            name="branch_id"
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <h3>Assign to</h3>
      <el-form-item label="" class="" label-width="0px">
        <el-radio-group v-model="editForm.category_type">
          <el-radio label="all_users">All Users</el-radio>
          <el-radio label="department">Department</el-radio>
          <el-radio label="station_grade">Grade</el-radio>
          <el-radio label="employees">Employees</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="mt-20 " v-show="editForm.category_type === 'department'">
        <el-form-item
          label="Select Department"
          prop="departments"
          class="mt-20"
        >
          <el-select
            v-model="editForm.departments"
            multiple
            placeholder="Select"
            style="width: 542px"
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.department_name"
              :value="department.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20" v-show="editForm.category_type === 'employees'">
        <el-form-item label="Select Employee" class="mt-20" prop="employees">
          <el-select
            style="width: 542px"
            v-model="editForm.employees"
            placeholder="Select"
            filterable
            remote
            :remote-method="searchEmployees"
            multiple
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20" v-show="editForm.category_type === 'station_grade'">
        <el-form-item label="Select Grade" class="mt-20" prop="grades">
          <el-select
            style="width: 542px"
            v-model="editForm.grades"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="grade in employeeGrades"
              :key="grade.id"
              :label="grade.grade_name"
              :value="grade.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label-width="0px">
        <el-button
          @click.prevent="update()"
          :loading="loading"
          class="btn btn-blue no-border btn-full-radius inline-flex mt-20 flex-v-end mr-15"
          >Save Changes</el-button
        >
        <button
          class="btn btn-light-gray no-border btn-full-radius inline-flex  mt-20 flex-v-end mr-15"
          @click.prevent="$router.go(-1)"
        >
          Cancel
        </button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    const customValidation = (rule, value, callback) => {
      const categoryTypeMap = {
        employees: this.editForm.employees,
        department: this.editForm.departments
          ? [this.editForm.departments]
          : [],
        station_grade: this.editForm.grades,
      };

      if (
        this.editForm.category_type !== "all_users" &&
        !categoryTypeMap[this.editForm.category_type].length > 0
      ) {
        return callback(new Error(`Please select ${rule.field}`));
      } else {
        return callback();
      }
    };
    return {
      editForm: {
        period_type: "Day",
        leave_name: "",
        weekend: [],
        exclude_public_holidays: true,
        applicable_days: "",
        gender: null,
        branch_id: null,
        category_type: "all_users",
        employees: [],
        departments: [],
        grades: [],
        note: "",
        is_generic: true,
        is_paid: true,
      },
      isGenderBased: false,
      genderList: [
        { id: 1, label: "Male", value: "male" },
        { id: 2, label: "Female", value: "female" },
      ],
      employees: [],
      loading: false,
      rules: {
        leave_name: [
          {
            required: true,
            message: "Please input leave type name",
            trigger: "blur",
          },
        ],
        applicable_days: [
          {
            required: true,
            message: "Please input leave duration",
            trigger: "blur",
          },
        ],
        category_type: [
          {
            required: true,
            message: "Please select category type ",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "Please select gender",
            trigger: "change",
          },
        ],
        branch_id: [
          { required: true, message: "Please branch ", trigger: "blur" },
        ],
        departments: [
          {
            required: true,
            message: "Please select department ",
            validator: customValidation,
          },
        ],
        grades: [
          {
            required: true,
            message: "Please select grade ",
            validator: customValidation,
          },
        ],
        employees: [
          {
            required: true,
            message: "Please select employee ",
            validator: customValidation,
          },
        ],
      },
    };
  },
  mounted() {
    this.getBranches();
    this.getEmployeeGrades();
    this.getDepartments();
    const id = this.$route.params.id;
    if (id) {
      this.findLeaveTypeById(id);
    }
  },
  computed: {
    ...mapState(["branches", "departments", "employeeGrades"]),
  },
  methods: {
    ...mapActions([
      "getBranches",
      "updateleaveType",
      "getEmployeeGrades",
      "getDepartments",
      "getLeaveTypeById",
    ]),
    findLeaveTypeById(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/hrm/leave/getLeaveTypeById", id)
        .then(response => {
          this.loading = false;
          const {
            id,
            branch,
            departments,
            note,
            employeeGrades,
            employees,
            applicable_days,
            category_type,
            is_generic,
            leave_name,
            weekend,
            exclude_public_holidays,
            period_type,
            gender,
            is_paid,
          } = response.data;

          // this.editForm.weekend = response.data.weekend === "Weekend" ? ["Saturday", "Sunday"] : [response.data.weekend];

          this.editForm.category_type =
            (employees.length > 0 && "employees") ||
            (departments.length > 0 && "department") ||
            (employeeGrades.length > 0 && "grade");

          const gradeIds = employeeGrades.map(x => x.id);
          const departmentIds = departments.map(x => x.id);
          const employeeIds = employees.map(x => x.id);
          this.employees = employees.map(x => ({
            ...x,
            name: x.employee_name,
          }));
          this.editForm = {
            id,
            branch_id: branch === null ? null : branch.id,
            category_type,
            departments: departmentIds,
            grades: gradeIds,
            employees: employeeIds,
            note,
            applicable_days,
            is_generic: is_generic === 1 ? true : false,
            leave_name,
            gender,
            weekend:
              weekend === "Weekend"
                ? ["Saturday", "Sunday"]
                : ["Saturday", "Sunday"].includes(weekend)
                ? [weekend]
                : [],
            exclude_public_holidays:
              exclude_public_holidays === undefined ||
              exclude_public_holidays === null
                ? true
                : Boolean(exclude_public_holidays),
            period_type,
            is_paid: is_paid === 1 ? true : false,
          };
          if (this.editForm.gender !== null) {
            return (this.isGenderBased = true);
          }
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    update() {
      this.$refs[`editForm`].validate(valid => {
        if (valid) {
          const id = this.$route.params.id;
          this.loading = true;
          const inputData = {
            leave_name: this.editForm.leave_name,
            weekend: this.editForm.weekend,
            exclude_public_holidays: this.editForm.exclude_public_holidays,
            applicable_days: this.editForm.applicable_days,
            period_type: this.editForm.period_type,
            ...(this.editForm.category_type === "all_users" && {
              category_type: this.editForm.category_type,
            }),
            ...(this.editForm.category_type === "department" && {
              category_type: this.editForm.category_type,
              departments: this.editForm.departments,
            }),
            ...(this.editForm.category_type === "station_grade" && {
              category_type: this.editForm.category_type,
              grades: this.editForm.grades,
            }),
            ...(this.editForm.category_type === "employees" && {
              category_type: this.editForm.category_type,
              employees: this.editForm.employees,
            }),
            branch_id:
              this.editForm.is_generic === true
                ? null
                : this.editForm.branch_id,
            is_generic: this.editForm.is_generic === true ? 1 : 0,
            note: this.editForm.note,
            is_paid: this.editForm.is_paid,
          };
          if (id) {
            const leaveName = this.editForm.leave_name.toLowerCase();
            if (leaveName.includes("maternity")) {
              this.editForm.gender = "female";
              const updatedinputData = {
                ...inputData,
                gender: this.editForm.gender,
              };
              this.updatedLeaveType(updatedinputData, id);
            } else if (leaveName.includes("paternity")) {
              this.editForm.gender = "male";
              const updatedinputData = {
                ...inputData,
                gender: this.editForm.gender,
              };
              this.updatedLeaveType(updatedinputData, id);
            } else if (this.isGenderBased === true) {
              const updatedinputData = {
                ...inputData,
                gender: this.editForm.gender,
              };
              this.updatedLeaveType(updatedinputData, id);
            } else {
              this.updatedLeaveType(inputData, id);
            }
          }
        }
      });
    },
    updatedLeaveType(dataForm, id) {
      this.$store
        .dispatch("admin/hrm/leave/updateLeaveType", {
          data: dataForm,
          id,
        })
        .then(() => {
          this.loading = false;
          this.$router.push({
            path: "/admin/hrm/leave/settings/leave-type",
          });
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
      return;
    },
    resetGenderRadioButton() {
      if (this.isGenderBased === false) {
        this.editForm.gender = null;
      }
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>
